import React, { useMemo } from 'react';

import type { SideBySideExperiment } from '@atlassian/search-experiment';

import { serveSearchPageRelayExp } from '../common/utils/experiments';

import { SearchPage as SearchPageFetch, type SearchPageProps } from './search-page';
import {
	SearchPage as SearchPageRelay,
	type SearchPageProps as SearchPageRelayProps,
} from './search-page-relay';

export function SearchPage(props: SearchPageProps & SearchPageRelayProps): React.JSX.Element {
	return serveSearchPageRelayExp(props.shell.primaryProduct, true, props.shell.queryParams) ? (
		<SearchPageRelay {...props} />
	) : (
		<SearchPageFetch {...props} />
	);
}

export type SearchPageSideBySideProps = SearchPageProps &
	SearchPageRelayProps & {
		experiments?: SideBySideExperiment[];
	};

export function SearchPageSideBySide({
	shell,
	experiments,
	...props
}: SearchPageSideBySideProps): React.JSX.Element {
	const shellWithSideBySide = useMemo(
		() => ({
			...shell,
			features: {
				sideBySide: {
					enabled: true,
					experiments,
				},
			},
		}),
		[shell, experiments],
	);
	return <SearchPageRelay {...props} shell={shellWithSideBySide} />;
}
